import React, { Component } from 'react';
import "../CSS/fonts/OpenSans-Bold.eot";
import "../CSS/fonts/OpenSans-Bold.ttf";
import "../CSS/fonts/OpenSans-Regular.eot";
import "../CSS/fonts/OpenSans-Regular.ttf";
import "../CSS/fonts/OpenSans-Semibold.eot";
import "../CSS/fonts/OpenSans-Semibold.ttf";
import "../CSS/CustomStyles.css";
import { GetResources, updateUrlParameter, convertDateToUTC } from "../scripts/ResourceManager.js";
import { HeaderFooter } from "./HeaderFooter";
import { Popup, ConfirmationPopupContent } from "./Popup";
import moment from "moment";
import SectionHeader from "./SectionHeader";
import VersionGrid from "./VersionGrid";
import VersionForm from "./VersionForm";
//import { adalApiFetch } from '../adalConfig';
import { adalConfigOptions, msalConfig } from '../msalConfig';
import { PublicClientApplication } from '@azure/msal-browser';

import { msalInstance } from '../msalConfig';
import { EventType } from '@azure/msal-browser';
//import { callMsGraph } from '../App';
import { loginRequest } from '../msalConfig';

import { useState } from 'react';
import { useEffect } from 'react';
import { useMsal } from '@azure/msal-react';

const loggedinAdalInstance = window.parent._adalInstance;
export class Admin extends Component {
    constructor(props) {
        super(props);
        this.state = {
            downloadData: {}, loading: true, resources: GetResources(), isAuthorized: null, dialogKey: "", deleteIndex: -1, formKey: "AdminDashboard", editIndex: -1, apiResponse: ""
        };
        const { loginUserADGroups } = this.props;
        const {loginUserAccessToken} = this.props;
        const accessToken = loginUserAccessToken;
console.log("Admin props",props);
        this.ToggleLanguage = this.ToggleLanguage.bind(this);
        this.DeleteVersion = this.DeleteVersion.bind(this);
        this.ShowDialog = this.ShowDialog.bind(this);
        this.ShowDeleteDialog = this.ShowDeleteDialog.bind(this);
        this.CloseDialog = this.CloseDialog.bind(this);
        this.ShowNewForm = this.ShowNewForm.bind(this);
        this.ShowEditForm = this.ShowEditForm.bind(this);
        this.ShowForm = this.ShowForm.bind(this);
        this.SaveForm = this.SaveForm.bind(this);
        this.CancelForm = this.CancelForm.bind(this);
        this.FormatPublishedDates = this.FormatPublishedDates.bind(this);
        
        // adalConfigOptions.then
        // (
        //     configValues => {
        //         var adalConfigValues = configValues;
        //         var authGroupValue=adalConfigValues.authGroup;
        // var authgroupValue=  fetch('api/admin/Admin/GetAdalConfig').then(apiresponse => apiresponse.json())
        //         .then(config => { 
        //             return config.authGroup     
        //         })
        //         console.log("authgroupValue",authgroupValue)

        
        
          var authgrp=  loginUserADGroups.value.filter(function(i)
         {
            //console.log(adalConfigValues.authGroup)
            //return i.id===authgroupValue;
              return i.id === 'fc09df52-cdca-4302-b257-b56597cc6195';
          })


          if(authgrp.length>0)
          {
           
            fetch('api/admin/Admin/FetchDownloadInfo', 
            { headers: { Authorization: `Bearer  ${accessToken }`, }}).
            then(response => {
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                  }
                  return response.json();

            }).then(data => {
                console.log(data); 
                   this.FormatPublishedDates(data.versionData);
                data.versionData.sort(function (a, b) { return (moment(b.publishedDate, "YYYY-MM-DD").toDate() - moment(a.publishedDate, "YYYY-MM-DD").toDate()); });
                this.setState({ downloadData: data.versionData, loading: false, mobileData: data.mobileDownloads, isAuthorized: true });

              }).catch(error => {
                console.error('Error fetching data:', error);
                // Handle any error that occurred during the fetch process
              });
           
          }
          else {
            this.setState({
                isAuthorized: false, loading: false

            });
        }
          
    }

    ToggleLanguage() {
        var newLangKey = this.state.resources.langKey == "EN" ? "FR" : "EN";
        if (window.history.pushState) {
            var newurl = updateUrlParameter(window.location.href, "lang", newLangKey);
            window.history.pushState({ path: newurl }, "", newurl);
        }
        this.setState({ resources: GetResources(newLangKey) });
    }

    DeleteVersion(deleteIndex) {
        var newDownloadData = this.state.downloadData;
        var deleteId = newDownloadData[deleteIndex].id;

        const {loginUserAccessToken} = this.props;
        const accessToken = loginUserAccessToken;
        fetch('api/admin/Admin/DeleteVersion?versionID=' + deleteId , 
            { method: 'POST',
                headers: {
                'Content-Type': 'application/json',
                 Authorization: `Bearer  ${accessToken }`,

        }}).
            then(response => {
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                  }
                  return response.json();

            }).then(data => {
                console.log(data); 
                if (data) {
                    this.FormatPublishedDates(data);
                    data.sort(function (a, b) { return (moment(b.publishedDate, "YYYY-MM-DD").toDate() - moment(a.publishedDate, "YYYY-MM-DD").toDate()); });
                    this.setState({ downloadData: data, dialogKey: "", deleteIndex: -1 });
                }
              }).catch(error => {
                console.error('Error fetching data:', error);
                // Handle any error that occurred during the fetch process
              });

        
        // fetch('api/admin/Admin/DeleteVersion?versionID=' + deleteId, {
        //     method: 'POST',
        //     headers: {
        //         'Content-Type': 'application/json'
        //     }
        // }).then((response) => response.json())
        //     .then((data) => {
        //         if (data) {
        //             this.FormatPublishedDates(data);
        //             data.sort(function (a, b) { return (moment(b.publishedDate, "YYYY-MM-DD").toDate() - moment(a.publishedDate, "YYYY-MM-DD").toDate()); });
        //             this.setState({ downloadData: data, dialogKey: "", deleteIndex: -1 });
        //         }
        //     })
        //     .catch((error) => {
        //         console.error(error);
        //     });

    }

    ShowDeleteDialog(delIndex) {
        this.setState({ dialogKey: "DeleteConfirmation", deleteIndex: delIndex });
    }

    CloseDialog() {
        this.setState({ dialogKey: "", deleteIndex: -1 });
    }

    ShowDialog() {
        switch (this.state.dialogKey) {
            case "DeleteConfirmation": {
                var versionToDel = this.state.downloadData[this.state.deleteIndex].version;
                var isPublished = this.state.downloadData[this.state.deleteIndex].published;
                var message = "Are you sure you want to delete <strong>" + versionToDel + "</strong >" + (isPublished ? " which is <strong>published</strong>?" : "?");
                return (<Popup dialogKey="DeleteConfirmation" dialogTitle="Delete Confirmation" classNames="" onClose={this.CloseDialog}><ConfirmationPopupContent message={message} okButtonText="Delete" onCancel={this.CloseDialog} onOk={() => this.DeleteVersion(this.state.deleteIndex)} /></Popup>);
            }
        }
        return null;
    }

    ShowNewForm() {
        this.setState({ formKey: "VersionNewForm" });
    }

    FormatPublishedDates(dataArray) {
        dataArray.map((data) => {
            if (!isNaN(data.publishedDate)) {
                data.publishedDate = moment.unix(data.publishedDate / 1000).format('YYYY-MM-DD');
            }
        });
    }

    SaveForm(newFormData, closeForm) {
        var newDownloadData = this.state.downloadData;
        const { editIndex } = this.state;
        if (editIndex > -1) {
            newFormData["modifiedDate"] = convertDateToUTC(new Date()).getTime();
            newDownloadData[editIndex] = newFormData;
        }
        else {
            newFormData["createdDate"] = convertDateToUTC(new Date()).getTime();
            newFormData["modifiedDate"] = convertDateToUTC(new Date()).getTime();
            newDownloadData.push(newFormData);
        }
        newFormData.downloadFileInfo.map((item) => {
            if (item.fileUrl != "") {
                var fUrl = item.fileUrl;
                var fUrlArry = fUrl.split("?");
                if (fUrlArry.length == 2) {
                    item.fileUrl = fUrlArry[0];
                }
            }
        });
        var formData = new FormData();
        newFormData["downloadFileInfo"].map((download, index) => {
            let fupload = document.getElementById("fileUpload_" + index);
            if (fupload.files.length > 0) {
                formData.append(download.fileName, fupload.files[0]);
            }
        });

        formData.append("downloadData", JSON.stringify(newFormData));
        //body: JSON.stringify({ updatedDownloadVersions: JSON.stringify(newDownloadData), uploadedFiles: uploadFiles })

        //headers: {
        //    'Content-Type': 'multipart/form-data'
        //},
        const {loginUserAccessToken} = this.props;
        const accessToken = loginUserAccessToken;
        const options = {
            
            method: 'POST',
            body: formData,
            headers: {
                //'Content-Type': 'multipart/form-data',
                 Authorization: `Bearer  ${accessToken }`,
            }
        };
        fetch('api/admin/Admin/SaveVersion', options)
            .then((response) =>{ if (!response.ok) {
                throw new Error('Network response was not ok');
              }
              return response.json();
            } )
            .then((data) => {
                if (data) {
                    this.FormatPublishedDates(data);
                    data.sort(function (a, b) { return (moment(b.publishedDate, "YYYY-MM-DD").toDate() - moment(a.publishedDate, "YYYY-MM-DD").toDate()); });
                    if (closeForm) {
                        this.setState({ formKey: "AdminDashboard", editIndex: -1, downloadData: data });
                    }
                    else {
                        this.setState({ downloadData: data });
                    }
                }
            })
            .catch((error) => {
                console.error(error);
            });

        //fetch('api/admin/Admin/UpdateDownloadVersions', {
        //    method: 'POST',
        //    headers: {
        //        'Content-Type': 'application/json'
        //    },
        //    body: JSON.stringify({ updatedDownloadVersions: JSON.stringify(newDownloadData) })
        //})
        //    .then((response) => response.json())
        //    .then((success) => {
        //        if (success) {
        //            if (closeForm) {
        //                this.setState({ formKey: "AdminDashboard", editIndex: -1, downloadData: newDownloadData });
        //            }
        //            else {
        //                this.setState({ downloadData: newDownloadData });
        //            }
        //        }
        //    })
        //    .catch((error) => {
        //        console.error(error);
        //    });
    }

    CancelForm() {
        //reload data
        const {loginUserAccessToken} = this.props;
        const accessToken = loginUserAccessToken;
        this.setState({ downloadData: {}, loading: true, formKey: "AdminDashboard", editIndex: -1 }, () =>

            fetch('api/admin/Admin/FetchDownloadInfo',
                { headers: { Authorization: `Bearer  ${accessToken}`, } }).
                then(response => {
                    if (!response.ok) {
                        throw new Error('Network response was not ok');
                    }
                    return response.json();

                }).then(data => {
                    console.log(data);
                    this.FormatPublishedDates(data.versionData);
                    data.versionData.sort(function (a, b) { return (moment(b.publishedDate, "YYYY-MM-DD").toDate() - moment(a.publishedDate, "YYYY-MM-DD").toDate()); });
                    this.setState({ downloadData: data.versionData, loading: false, mobileData: data.mobileDownloads, isAuthorized: true });

                })
            
            //fetch('api/admin/Admin/FetchDownloadInfo')
            //.then(response => response.json())
            //.then(data => {
            //    this.FormatPublishedDates(data.versionData);
            //    data.versionData.sort(function (a, b) { return (moment(b.publishedDate, "YYYY-MM-DD").toDate() - moment(a.publishedDate, "YYYY-MM-DD").toDate()); });
            //    this.setState({ downloadData: data.versionData, loading: false, mobileData: data.mobileDownloads });
            //})
        );
    }

    ShowForm() {
        switch (this.state.formKey) {
            case "AdminDashboard": {
                var Dialog = this.ShowDialog();
                return (<div className={"CA-Dashboard col-12 p-3 px-5 mb-2"}>
                    <SectionHeader><span className={"col-4 px-0 CA-title pl-1"}>Dashboard</span>
                        <span className={"col-8 px-0 float-end text-end pe-1"}><button className={"CA-newDocument CTA-active ca-primarybtn border-0"} onClick={this.ShowNewForm}>New Document</button></span></SectionHeader><VersionGrid versionData={this.state.downloadData} onVersionDelete={(index) => this.ShowDeleteDialog(index)} onVersionEdit={index => this.ShowEditForm(index)} />{Dialog}</div>);
            }

            case "VersionNewForm": {
                const versionTemplate = { "id": "", "version": "", "publishedDate": moment().format("YYYY-MM-DD"), "published": false, "verionDescriptionEN": "", "verionDescriptionFR": "", "createdDate": 0, "modifiedDate": 0, "downloadFileInfo": [{ "fileTypeName": "Excel add-in", "fileName": "", "fileUrl": "", "fileLinkDescriptionEN": "", "fileLinkDescriptionFR": "", "fileBlobName": "" }, { "fileTypeName": "Leaf application", "fileName": "", "fileUrl": "", "fileLinkDescriptionEN": "", "fileLinkDescriptionFR": "", "fileBlobName": "" }] };
                var formData = versionTemplate;
                return (
                    <VersionForm formData={formData} onCancel={this.CancelForm} onSaveForm={(newFormData, closeForm) => this.SaveForm(newFormData, closeForm)} mobileData={this.state.mobileData} allVersionData={this.state.downloadData} />
                );
            }

            case "VersionEditForm": {
                var formData = this.state.downloadData[this.state.editIndex];
                return (<VersionForm formData={formData} onCancel={this.CancelForm} onSaveForm={(newFormData, closeForm) => this.SaveForm(newFormData, closeForm)} mobileData={this.state.mobileData} allVersionData={this.state.downloadData} />);
            }
        }
        return null;
    }

    ShowEditForm(editIndex) {
        this.setState({ formKey: "VersionEditForm", editIndex: editIndex });
    }

    render() {
        //console.log(this.state.downloadData);
        var Form = this.ShowForm();
        //const { editorState } = this.state;
        return (
            this.state.isAuthorized ? <HeaderFooter langResources={this.state.resources} langToggleClick={this.ToggleLanguage} hasLangToggle={false}>
                {this.state.loading ?
                    <div className="CA-container"><p><em>Loading...</em></p></div> : <div className="CA-container">{Form}</div>}
            </HeaderFooter> :
                this.state.loading ? <div className="CA-container"><p><em>Loading...</em></p></div> :
                    <div>you are not authorized to access the admin portal</div>
            //<div>
            //    <p>API response:</p>
            //    <pre>{this.state.apiResponse}</pre>
            //</div>
        );
    }
}


